// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function slotForPosition(position) {
  switch (position) {
    case "AboveLogo" :
        return "AboveLogoSlot";
    case "BelowLogo" :
        return "BelowLogoSlot";
    case "AboveButtons" :
        return "AboveButtonsSlot";
    case "BelowButtons" :
        return "BelowButtonsSlot";
    case "BottomLeft" :
    case "BottomRight" :
    case "BottomCenter" :
        return "FixedSlot";
    case "Hidden" :
        return "HiddenSlot";
    default:
      return "TopBarSlot";
  }
}

function fromString(str) {
  switch (str) {
    case "bottom_center" :
    case "fixed_bottom_center" :
        return "BottomCenter";
    case "bottom_left" :
    case "fixed_top_left" :
        return "BottomLeft";
    case "bottom_right" :
    case "fixed_top_right" :
        return "BottomRight";
    case "above_buttons" :
    case "above_content" :
    case "below_content" :
    case "inline_buttons_left" :
        return "AboveButtons";
    case "below_buttons" :
    case "inline_buttons_right" :
        return "BelowButtons";
    case "below_logo" :
    case "inline_logo_right" :
        return "BelowLogo";
    case "above_logo" :
    case "inline_logo_left" :
    case "inside_content_top" :
        return "AboveLogo";
    case "top_center" :
    case "top_full_width" :
        return "TopCenter";
    case "top_left" :
        return "TopLeft";
    case "top_right" :
        return "TopRight";
    default:
      return "Hidden";
  }
}

function toString(position) {
  switch (position) {
    case "TopLeft" :
        return "top_left";
    case "TopCenter" :
        return "top_center";
    case "TopRight" :
        return "top_right";
    case "AboveLogo" :
        return "above_logo";
    case "BelowLogo" :
        return "below_logo";
    case "AboveButtons" :
        return "above_buttons";
    case "BelowButtons" :
        return "below_buttons";
    case "BottomLeft" :
        return "bottom_left";
    case "BottomRight" :
        return "bottom_right";
    case "BottomCenter" :
        return "bottom_center";
    case "Hidden" :
        return "hidden";
    
  }
}

function label(position) {
  switch (position) {
    case "TopLeft" :
        return "Top Left";
    case "TopCenter" :
        return "Top Center";
    case "TopRight" :
        return "Top Right";
    case "AboveLogo" :
        return "Above Logo";
    case "BelowLogo" :
        return "Below Logo";
    case "AboveButtons" :
        return "Above Button";
    case "BelowButtons" :
        return "Below Button";
    case "BottomLeft" :
        return "Bottom Left";
    case "BottomRight" :
        return "Bottom Right";
    case "BottomCenter" :
        return "Bottom Center";
    case "Hidden" :
        return "Hidden";
    
  }
}

function shouldShowSelector(surveyLanguages, position) {
  if (position === "Hidden" || !(surveyLanguages && surveyLanguages.tl)) {
    return false;
  } else {
    return true;
  }
}

function matchesSlot(position, expectedSlot) {
  return slotForPosition(position) === expectedSlot;
}

var selectHeightClass = "h-40-px";

function selectWidthClass(position) {
  switch (position) {
    case "AboveButtons" :
    case "BelowButtons" :
        return "w-full max-w-150-px";
    default:
      return "w-150-px";
  }
}

function containerClass(width) {
  if (width === "Narrow") {
    return "max-w-440-px mx-auto";
  } else {
    return "max-w-840-px mx-auto";
  }
}

function horizontalPadding(width) {
  if (width === "Narrow") {
    return "px-40-px small:px-20-px";
  } else {
    return "px-60-px small:px-20-px";
  }
}

function centeredContainer(width) {
  var padding = horizontalPadding(width);
  if (width === "Narrow") {
    return "max-w-440-px mx-auto " + padding;
  } else {
    return "max-w-840-px mx-auto " + padding;
  }
}

function wrapperClasses(position, width) {
  var centered = centeredContainer(width);
  var fullWidth = "w-full " + horizontalPadding(width);
  switch (position) {
    case "TopLeft" :
        return fullWidth + " " + selectHeightClass + " p-1 flex items-center justify-start";
    case "TopCenter" :
        return centered + " " + selectHeightClass + " p-1 flex items-center justify-center";
    case "TopRight" :
        return fullWidth + " " + selectHeightClass + " p-1 flex items-center justify-end";
    case "AboveLogo" :
    case "BelowLogo" :
        break;
    case "AboveButtons" :
    case "BelowButtons" :
        return "w-full flex items-center justify-center py-1";
    case "BottomLeft" :
        return "fixed bottom-0 left-0 z-50 p-2";
    case "BottomRight" :
        return "fixed bottom-0 right-0 z-50 p-2";
    case "BottomCenter" :
        return "fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center p-2";
    case "Hidden" :
        return "";
    
  }
  return centered + " " + selectHeightClass + " py-1 flex items-center justify-end";
}

var $$default = "Hidden";

var allPositions = {
  hd: "TopLeft",
  tl: {
    hd: "TopRight",
    tl: {
      hd: "TopCenter",
      tl: {
        hd: "AboveLogo",
        tl: {
          hd: "BelowLogo",
          tl: {
            hd: "AboveButtons",
            tl: {
              hd: "BelowButtons",
              tl: {
                hd: "BottomLeft",
                tl: {
                  hd: "BottomRight",
                  tl: {
                    hd: "BottomCenter",
                    tl: {
                      hd: "Hidden",
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

exports.default = $$default;
exports.__esModule = true;
exports.slotForPosition = slotForPosition;
exports.fromString = fromString;
exports.toString = toString;
exports.allPositions = allPositions;
exports.label = label;
exports.shouldShowSelector = shouldShowSelector;
exports.matchesSlot = matchesSlot;
exports.selectHeightClass = selectHeightClass;
exports.selectWidthClass = selectWidthClass;
exports.containerClass = containerClass;
exports.horizontalPadding = horizontalPadding;
exports.centeredContainer = centeredContainer;
exports.wrapperClasses = wrapperClasses;
/* No side effect */
